/**
 * Parts and vendor parts API calls.
 */

import client from './client';

// --- Parts ---

export async function fetchParts(params = {}) {
  const { data } = await client.get('/parts/', { params });
  return data;
}

export async function fetchPart(id) {
  const { data } = await client.get(`/parts/${id}/`);
  return data.data || data;
}

export async function createPart(payload) {
  const { data } = await client.post('/parts/', payload);
  return data.data || data;
}

export async function updatePart(id, payload) {
  const { data } = await client.patch(`/parts/${id}/`, payload);
  return data.data || data;
}

export async function deletePart(id) {
  await client.delete(`/parts/${id}/`);
}

export async function restorePart(id) {
  const { data } = await client.post(`/parts/${id}/restore/`);
  return data.data || data;
}

// --- Vendor Parts ---

export async function fetchVendorParts(params = {}) {
  const { data } = await client.get('/parts/vendor-parts/', { params });
  return data;
}

export async function fetchVendorPart(id) {
  const { data } = await client.get(`/parts/vendor-parts/${id}/`);
  return data.data || data;
}

export async function createVendorPart(payload) {
  const { data } = await client.post('/parts/vendor-parts/', payload);
  return data.data || data;
}

export async function updateVendorPart(id, payload) {
  const { data } = await client.patch(`/parts/vendor-parts/${id}/`, payload);
  return data.data || data;
}

export async function deleteVendorPart(id) {
  await client.delete(`/parts/vendor-parts/${id}/`);
}

export async function restoreVendorPart(id) {
  const { data } = await client.post(`/parts/vendor-parts/${id}/restore/`);
  return data.data || data;
}

export async function setPreferredVendorPart(id) {
  const { data } = await client.post(`/parts/vendor-parts/${id}/set-preferred/`);
  return data.data || data;
}
